import { FC } from 'react'
import { ICard } from 'types/ui/card.interface'
import { StyledCard } from './Card.styled'

export const Card: FC<ICard> = ({ glow = false, children, ...rest }) => {
  return (
    <StyledCard $glow={glow} {...rest}>
      {children}
    </StyledCard>
  )
}
